// extracted by mini-css-extract-plugin
export default {"pageContainer":"ProductionSchemesTabPage_pageContainer__h+ng3"};